import React, { useEffect, useState } from "react";
import style from "./style.module.scss"
import { Github } from "../../../services/github/service";
import dayjs from 'dayjs'
import DataTable from "../../dataTable";
import SideModal from "../../sideModal";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
// get bar chart from recharts
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
const UserDashboard = ({ user, loading, repos }) => {
    const [showModal, setShowModal] = useState(false);
    const [activeSort, setActiveSort] = useState()
    const [commitLoading, setCommitLoading] = useState(false);
    const [contributors, setContributors] = useState([{}]);
    const [contributorsLoading, setContributorsLoading] = useState(false);
    const [filteredRepos, setRepos] = useState([...repos])

    const [activeRepo, setActiveRepo] = useState([{}]);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                label: 'Commits',
                data: [],
                fill: false,
                backgroundColor: 'rgb(255, 99, 132)',
                borderColor: 'rgba(255, 99, 132, 0.2)',
            },
        ],
    });
    // improve this by using an object format
    const columns = ["Name", "Language", "Stars", "Forks", "Open Issues"]
    const rows = filteredRepos.map(repo => {
        return [repo.name, repo.language, repo.stargazers_count, repo.forks, repo.open_issues]
    })

    useEffect(() => {
        setRepos(repos)
    }, [repos])

    const setFilteredRepos = (sortFilter)=>{
        
        let filteredRepos = [...repos]
        if(sortFilter === "Stars"){
            if(activeSort === "Stars"){
                filteredRepos.sort((a, b) => a.stargazers_count - b.stargazers_count)
                setActiveSort("")
            }else{
                filteredRepos.sort((a, b) => b.stargazers_count - a.stargazers_count)
                setActiveSort(sortFilter)

            }
        }else if(sortFilter === "Forks"){

             if(activeSort === "Forks"){
                filteredRepos.sort((a, b) => a.forks - b.forks)
                setActiveSort("")

            }else{
                filteredRepos.sort((a, b) => b.forks - a.forks)
                setActiveSort(sortFilter)

            }
        }else if(sortFilter === "Open Issues"){
        
            if(activeSort === "Open Issues"){
                filteredRepos.sort((a, b) => a.open_issues - b.open_issues)
                setActiveSort("")

            }else{
                filteredRepos.sort((a, b) => b.open_issues - a.open_issues)
                setActiveSort(sortFilter)

            
            }
        }
        setRepos(filteredRepos)
    }

    const onColumnClick = (column) => {
        
        setFilteredRepos(column)
    }


    const handleRowClick = (row) => {
        // fix this
        let activeRepo = row[0]
        setActiveRepo(activeRepo);
        getRepoCommitActivity(user.login, activeRepo);
        getRepoContributors(user.login, activeRepo);
        setShowModal(true)
    }
    const closeModal = (e) => {
        setShowModal(false)
    }
    const getRepoCommitActivity = async (username, repo) => {
        setCommitLoading(true);
        const { status, data: response } = await Github.getRepoCommitActivity(username, repo);
        if (status === 202) {
            setTimeout(() => {
                getRepoCommitActivity(username, repo);
            }, 2000);
            return;
        } else if (status === 200) {
            let data = {
                labels: response.map((week) => dayjs.unix(week.week).format('DD MMM')),
                datasets: [
                    {
                        label: 'Commits',
                        data: response.map((week) => week.total),
                        fill: false,
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgba(255, 99, 132, 0.2)',
                    },
                ],
            };
            setChartData(data);
            setCommitLoading(false);
        }

        // set the commit history to the state and chart data

    }

    const getRepoContributors = async (username, repo) => {
        setContributorsLoading(true);
        const response = await Github.getRepoContributors(username, repo);
        setContributors(response);
        setContributorsLoading(false);
    }
    const options = {
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    display: true,
                    autoSkip: true,
                    autoSkipPadding: 25,
                    maxRotation: 0,
                    minRotation: 0,
                },
            },
            y: {
                position: "left",

                grid: {
                    display: true,
                    //@ts-ignore
                    drawBorder: false,
                    borderDash: [8, 4],
                },
                ticks: {
                    display: true,
                    maxTicksLimit: 5,
                },
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },
            title: {
                display: false,
            },
        },
    };

    const CommitHistoryVisualization = () => {
        return (
            <div className={style.commitHistory}>
                <div className={style.content}>
                    <div className={style.title}>{user.name}/{activeRepo}</div>
                    <div className={style.description}>
                        Repository Analytics
                    </div>
                </div>
                {
                    commitLoading ? <div className={`skeleton-loader ${style.emptyChart}`}></div> :
                        <div className={style.chart}>
                            <div className={style.title}>Commit history over the year</div>
                            <Line options={options} data={chartData} /></div>
                }

            </div>
        )
    }
    const getContributorsSkeleton = ()=>{
        let skeleton =[]
        for(let i=0;i<5;i++){
            skeleton.push(
                <div className={style.contributorSkeleton}>
                    <div className={`skeleton-loader ${style.avatar}`}>
                    </div>
                    <div className={`${style.details}`}>
                        <span className={`skeleton-loader ${style.name}`}></span>
                        <span className={`skeleton-loader ${style.description}`}></span>
                    </div>
                </div>
            )
        }
        return skeleton
    }

    const ContributersList = () => {
        return (
            <div className={style.contributors}>
                <div className={style.title}>Contributors</div>
                {
                    contributorsLoading ?  <div className={style.list}> {getContributorsSkeleton()} </div>: <div className={style.list}>
                        {
                            contributors.map(contributor => {
                                return <div className={style.contributor}>
                                    <div className={style.avatar}>
                                        <img src={contributor.avatar_url} alt="avatar" />
                                    </div>
                                    <div className={style.details}>
                                        <span className={style.name}>{contributor.login}</span>
                                        <span className={style.description}>{contributor.contributions} contributions</span>
                                    </div>
                                </div>
                            })
                        }
                    </div>

                }

            </div>
        )
    }


    return <div className={style.userDashboard}>
        {
            showModal && <SideModal close={closeModal} >
                <CommitHistoryVisualization />
                <ContributersList />
            </SideModal>
        }
        {
            loading ? <div className={style.userInfoSkeleton}>
                <div className={`${style.avatar} skeleton-loader`}>

                </div>
                <div className={`${style.userDetails}`}>
                    <span className={`${style.name} skeleton-loader`}></span>
                    <span className={`${style.description} skeleton-loader`}></span>
                    <span className={`${style.bio} skeleton-loader`}></span>
                </div>
            </div>
                : <div className={style.userInfo}>
                    <div className={style.avatar}>
                        <img src={user.avatar_url} alt="avatar" />
                    </div>
                    <div className={style.userDetails}>
                        <span className={style.name}>{user.name}</span>
                        <span className={style.description}>{user.login}</span>
                        <span className={style.bio}>{user.bio}</span>
                    </div>
                </div>
        }

        <div className={style.repos}>
            <div className={style.title}>Repositories</div>
            <DataTable columClicked={onColumnClick} loading={loading} rowClicked={handleRowClick} data={
                {
                    columns: columns,
                    rows: rows
                }
            } />
        </div>

    </div>
}

export default UserDashboard;